import React, { useEffect } from 'react';
import {
  Typography,
  ThemeProvider,
} from '@mui/material';
import { Logout } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { cookieOptions } from '../CookieHelper';
import { theme } from '../styles/theme/theme';
import {
  AuthPageContainer,
  AuthFormCard,
  AuthGradientButton,
  AuthPageTitle,
} from '../styles/components';

const SignOff: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Clear all cookies except 'GuestId'
    const allCookies = Cookies.get();
    for (const cookieName in allCookies) {
      if (cookieName !== 'GuestId') {
        Cookies.remove(cookieName, cookieOptions);
      }
    }
    
    // Redirect to sign-in page after a short delay
    const timer = setTimeout(() => {
      navigate('/sign-in');
    }, 2000); // 2-second delay

    return () => clearTimeout(timer); // Cleanup timer on unmount
  }, [navigate]);

  return (
    <ThemeProvider theme={theme}>
      <AuthPageContainer>
        <AuthFormCard elevation={6}>
          <AuthPageTitle variant="h5">
            Signed Off
          </AuthPageTitle>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3, textAlign: 'center' }}>
            You have been signed off. Thank you for using our service.
          </Typography>
          <AuthGradientButton
            fullWidth
            variant="contained"
            startIcon={<Logout />}
            onClick={() => navigate('/sign-in')}
          >
            Go to Sign In
          </AuthGradientButton>
        </AuthFormCard>
      </AuthPageContainer>
    </ThemeProvider>
  );
};

export default SignOff; 